import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, type FC } from 'react';
import cn from 'classnames';
import { CategoryID, type AdItem as AdItemType } from '@sbt-web/network/types';
import { AdItemCardResponsive, isCategoryForLargeCard } from '@sbt-web/item-card';
import { useAppSelector } from '@/reducers/common';
import type { RootState } from '@/reducers/index';
import { HADES_PATH } from '@/shared/constants';
import { getRankFor } from '@/shared/helpers/Rank';
import { buildCardClickTrackingData, buildCardImpressionTrackingViewData, getTrackingItem } from '@/tools/tracking/adsListingImpressionsTracking/buildCardImpressionTrackingData';
import { useTrackImpression } from '@/tools/tracking/useTrackImpression';
import { getOrCreatePulse } from '@/tools/tracking/utils';
import '@sbt-web/item-card/dist/index.css';
import styles from './AdItem.module.scss';
type Props = {
  index: number;
  item: AdItemType;
  listingCategory: CategoryID;
  handleItemClick?: () => void;
};
export const AdItem: FC<Props> = t0 => {
  const $ = _c(24);
  const {
    index,
    item,
    listingCategory,
    handleItemClick
  } = t0;
  const searchingInDialog = useAppSelector(_temp);
  const searchId = useAppSelector(_temp2);
  let t1;
  if ($[0] !== item.gallerized || $[1] !== item.urn) {
    t1 = t2 => {
      const {
        items,
        search: search_1
      } = t2;
      return getRankFor(item.urn, item.gallerized ? "GalleryItem" : "AdItem", search_1, items);
    };
    $[0] = item.gallerized;
    $[1] = item.urn;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const rank = useAppSelector(t1);
  let t2;
  if ($[3] !== rank || $[4] !== searchId) {
    t2 = searchId ? {
      id: searchId,
      rank
    } : undefined;
    $[3] = rank;
    $[4] = searchId;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const search_2 = t2;
  const bigCard = isCategoryForLargeCard(listingCategory);
  const itemCardRef = useRef(null);
  const setItemCardRef = useTrackImpression({
    enabled: search_2?.id !== undefined && !searchingInDialog,
    track: () => {
      getOrCreatePulse()?.queueEvent(buildCardImpressionTrackingViewData(getTrackingItemLocal()));
    }
  });
  const getTrackingItemLocal = () => getTrackingItem(item, item.gallerized ? "gallery" : "listing", search_2?.id ?? "", search_2?.rank ?? -1);
  let t3;
  let t4;
  if ($[6] !== setItemCardRef) {
    t3 = () => {
      if (itemCardRef?.current) {
        setItemCardRef(itemCardRef.current);
      }
    };
    t4 = [setItemCardRef, itemCardRef];
    $[6] = setItemCardRef;
    $[7] = t3;
    $[8] = t4;
  } else {
    t3 = $[7];
    t4 = $[8];
  }
  useEffect(t3, t4);
  const T0 = AdItemCardResponsive;
  const t5 = HADES_PATH;
  const t6 = process;
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = getOrCreatePulse();
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== getTrackingItemLocal || $[11] !== handleItemClick) {
    t8 = () => {
      getOrCreatePulse()?.queueEvent(buildCardClickTrackingData(getTrackingItemLocal()));
      handleItemClick?.();
    };
    $[10] = getTrackingItemLocal;
    $[11] = handleItemClick;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const t9 = "listing";
  const t10 = bigCard ? index >= 2 : index >= 4;
  const t11 = bigCard ? "large" : "small";
  const t12 = cn(styles.adItemCard, {
    [styles.large]: bigCard
  });
  let t13;
  if ($[13] !== T0 || $[14] !== item || $[15] !== search_2 || $[16] !== t10 || $[17] !== t11 || $[18] !== t12 || $[19] !== t5 || $[20] !== t6.env.NEXT_PUBLIC_ASSETS_BASE_URL || $[21] !== t7 || $[22] !== t8) {
    t13 = <T0 item={item} apiBase={t5} assetsBase={t6.env.NEXT_PUBLIC_ASSETS_BASE_URL} search={search_2} ref={itemCardRef} pulseInstance={t7} onClick={t8} pageTypeForTracking={t9} lazyLoad={t10} variant={t11} className={t12} />;
    $[13] = T0;
    $[14] = item;
    $[15] = search_2;
    $[16] = t10;
    $[17] = t11;
    $[18] = t12;
    $[19] = t5;
    $[20] = t6.env.NEXT_PUBLIC_ASSETS_BASE_URL;
    $[21] = t7;
    $[22] = t8;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  return t13;
};
function _temp(t0) {
  const {
    search
  } = t0;
  return search.filtersDialogOpen || search.radiusDialogOpen;
}
function _temp2(t0) {
  const {
    search: search_0
  } = t0;
  return search_0.id;
}